export const BASE_URL = "https://api.handivisible.fr/api";
// export const BASE_URL = "http://127.0.0.1:8000/api";
// export const BASE_URL = "http://192.168.1.43:8000/api";
